export default function EvaluationSupport() {
  return (
    <section id="evaluation" className="py-32 bg-gradient-to-br from-white via-blue-50/30 to-white relative overflow-hidden">
      {/* Background Decoration */}
      <div className="absolute top-20 left-10 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>
      <div className="absolute bottom-20 right-10 w-96 h-96 bg-blue-500/5 rounded-full blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 relative z-10">
        {/* Section Header */}
        <div className="text-center mb-20">
          <span className="inline-block px-5 py-2 bg-blue-500/10 text-blue-600 text-sm font-semibold rounded-full mb-6 whitespace-nowrap">
            EVALUATION & OPERATION SUPPORT
          </span>
          <h2 className="text-5xl font-bold text-gray-900 mb-6 whitespace-nowrap">
            평가·운영 지원
          </h2>
          <p>
            장기요양기관의 성공적인 운영을 위한<br />
            전문적인 평가 준비 및 운영 컨설팅 서비스
          </p>
        </div>

        {/* Hero Image */}
        <div className="mb-24 relative group">
          <div className="absolute inset-0 bg-gradient-to-br from-blue-500/20 to-transparent rounded-3xl transform rotate-1 group-hover:rotate-0 transition-transform duration-500"></div>
          <img 
            src="https://public.readdy.ai/ai/img_res/60e2a537cc9a352ba9d8cdb124d11b62.jpg"
            alt="평가·운영 지원"
            className="relative rounded-3xl shadow-2xl w-full h-[400px] object-cover transform group-hover:scale-[1.02] transition-transform duration-500"
          />
        </div>

        {/* Section 1: 평가와 보험의 연결 */}
        <div className="mb-24">
          <div className="bg-gradient-to-br from-gray-50 to-white rounded-2xl md:rounded-3xl overflow-hidden border-2 border-blue-500/20 shadow-xl">
            <div className="bg-gradient-to-r from-[#4A90E2] to-[#357ABD] px-6 md:px-8 py-4 md:py-5">
              <h3 className="text-white font-bold text-xl md:text-2xl">평가와 보험, 분리되지 않습니다</h3>
            </div>
            
            <div className="p-6 md:p-10">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8 mb-6">
                <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-file-list-3-line text-2xl md:text-3xl text-blue-600"></i>
                  </div>
                  <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3">평가 항목 속 보험</h4>
                  <p className="text-sm md:text-base text-gray-600 mb-4">
                    요양기관 평가에는 배상책임보험 가입과 사고 대응 체계가 포함되어 있습니다.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-sm md:text-base text-gray-700">안전관리 체계 구축</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-sm md:text-base text-gray-700">사고 대응 절차</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-sm md:text-base text-gray-700">보험 가입 및 보장 범위</span>
                    </li>
                  </ul>
                </div>

                <div className="bg-white rounded-xl md:rounded-2xl p-6 md:p-8 border border-gray-200 shadow-sm hover:shadow-lg transition-all duration-300">
                  <div className="w-12 h-12 md:w-14 md:h-14 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                    <i className="ri-shield-check-line text-2xl md:text-3xl text-blue-600"></i>
                  </div>
                  <h4 className="text-lg md:text-xl font-bold text-gray-900 mb-3">케어인슈의 접근</h4>
                  <p className="text-sm md:text-base text-gray-600 mb-4">
                    평가 기준에 맞춘 사고 대응 체계를 실제로 구축하고 운영합니다.
                  </p>
                  <ul className="space-y-2">
                    <li className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-sm md:text-base text-gray-700">평가 기준 맞춤 사고 처리</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-sm md:text-base text-gray-700">체계적 기록 관리</span>
                    </li>
                    <li className="flex items-start gap-2">
                      <div className="w-1.5 h-1.5 bg-blue-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span className="text-sm md:text-base text-gray-700">평가 점수 향상 기여</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div className="bg-gradient-to-br from-emerald-50 to-white rounded-xl md:rounded-2xl p-5 md:p-6 border border-emerald-200">
                <div className="flex items-start gap-3">
                  <i className="ri-information-line text-emerald-600 text-xl md:text-2xl mt-0.5"></i>
                  <div>
                    <p className="text-sm md:text-base font-semibold text-gray-900 mb-2">핵심 포인트</p>
                    <p className="text-sm md:text-base text-gray-600">
                      케어인슈는 단순한 보험이 아닌, 평가 대비와 운영 개선을 함께 지원하는 통합 솔루션입니다.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section 2: 4가지 핵심 지원 영역 - 바둑판 배열 */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 whitespace-nowrap">4가지 핵심 지원 영역</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {/* Card 1 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-blue-500/20">
              <div className="relative h-40 mb-4 rounded-xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Korean%20elderly%20care%20facility%20safety%20management%20training%20with%20Korean%20professional%20instructor%20teaching%20emergency%20response%20and%20accident%20prevention%20protocols%20to%20Korean%20healthcare%20staff%20in%20modern%20bright%20training%20room%20with%20safety%20equipment%20checklist%20and%20educational%20posters%20showing%20systematic%20organized%20professional%20safety%20approach%20with%20Korean%20people&width=400&height=300&seq=eval-item1-safety-korean-003&orientation=squarish"
                  alt="안전관리 체계"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-3">
                <i className="ri-shield-star-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2 whitespace-nowrap">안전관리 체계</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>사고 예방 교육</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>안전 매뉴얼 구축</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>정기 안전 점검</span>
                </li>
              </ul>
            </div>

            {/* Card 2 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-blue-500/20">
              <div className="relative h-40 mb-4 rounded-xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20Korean%20medical%20staff%20in%20modern%20healthcare%20facility%20organizing%20and%20managing%20detailed%20accident%20incident%20reports%20and%20emergency%20documentation%20system%20with%20digital%20records%20and%20safety%20protocols%20in%20clean%20organized%20Korean%20medical%20office%20setting&width=400&height=300&seq=eval-item2-korean-new-002&orientation=squarish"
                  alt="사고 보고 체계"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-3">
                <i className="ri-file-shield-2-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2 whitespace-nowrap">사고 기록 관리</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>평가 기준 맞춤 기록</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>체계적 문서화</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>신속한 사고 처리</span>
                </li>
              </ul>
            </div>

            {/* Card 3 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-blue-500/20">
              <div className="relative h-40 mb-4 rounded-xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20Korean%20healthcare%20consultants%20team%20collaborating%20in%20modern%20medical%20facility%20reviewing%20quality%20improvement%20plans%20and%20service%20enhancement%20strategies%20with%20Korean%20staff%20members%20in%20bright%20clean%20office%20environment%20with%20medical%20charts%20and%20quality%20assessment%20documents%20on%20table%20showing%20teamwork%20and%20dedication%20to%20excellence%20in%20long%20term%20care%20services&width=400&height=300&seq=eval-item3-korean-new-002&orientation=squarish"
                  alt="서비스 품질 관리"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-3">
                <i className="ri-star-smile-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2 whitespace-nowrap">서비스 품질 향상</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>품질 개선 컨설팅</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>직원 교육 프로그램</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>만족도 향상 전략</span>
                </li>
              </ul>
            </div>

            {/* Card 4 */}
            <div className="bg-white rounded-2xl p-6 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-blue-500/20">
              <div className="relative h-40 mb-4 rounded-xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=experienced%20Korean%20attorney%20in%20formal%20business%20suit%20providing%20professional%20legal%20consultation%20to%20Korean%20healthcare%20facility%20director%20in%20modern%20Korean%20law%20office%20with%20legal%20documents%20compliance%20files%20and%20law%20books%20on%20desk%20showing%20serious%20professional%20discussion%20about%20elderly%20care%20facility%20regulations%20and%20legal%20compliance%20matters%20with%20clean%20professional%20office%20background%20natural%20lighting%20and%20trustworthy%20atmosphere%20Korean%20people%20only&width=400&height=300&seq=eval-item4-legal-korean-consultation-010&orientation=squarish"
                  alt="법적 준수 사항"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-3">
                <i className="ri-scales-3-line text-2xl text-blue-600"></i>
              </div>
              <h4 className="text-lg font-bold text-gray-900 mb-2 whitespace-nowrap">법률 자문</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>사고 관련 법률 자문</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>분쟁 조정 지원</span>
                </li>
                <li className="flex items-start gap-2 text-xs text-gray-600">
                  <i className="ri-check-line text-blue-500 mt-0.5"></i>
                  <span>법규 준수 점검</span>
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Section 3: 형식적 보험 vs 실질적 지원 */}
        <div className="mb-24">
          <div className="bg-gradient-to-br from-red-50 to-white rounded-3xl p-12 shadow-xl border-2 border-red-500/20">
            <div className="mb-8">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900">형식적 보험이 아닙니다</h3>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
              <div className="bg-white rounded-2xl p-8 shadow-md">
                <div className="relative h-48 mb-6 rounded-xl overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=frustrated%20Korean%20elderly%20care%20facility%20manager%20dealing%20with%20formal%20insurance%20paperwork%20and%20bureaucracy%20showing%20ineffective%20insurance%20system%20with%20stacks%20of%20documents%20in%20cluttered%20office%20with%20Korean%20people&width=600&height=400&seq=formal-insurance-korean-001&orientation=landscape"
                    alt="형식적 보험의 문제"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex items-center gap-3 mb-4">
                  <i className="ri-close-circle-line text-3xl text-red-500"></i>
                  <h4 className="text-xl font-bold text-gray-900 whitespace-nowrap">일반 보험</h4>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-error-warning-line text-red-500 mt-1"></i>
                    <div>
                      <p>증권만 제출</p>
                      <p>실제 사고 대응 불가</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-error-warning-line text-red-500 mt-1"></i>
                    <div>
                      <p>처리 지연</p>
                      <p>평가 감점 위험</p>
                    </div>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-8 shadow-md">
                <div className="relative h-48 mb-6 rounded-xl overflow-hidden">
                  <img 
                    src="https://readdy.ai/api/search-image?query=professional%20Korean%20elderly%20care%20insurance%20team%20providing%20real%20support%20and%20consultation%20with%20Korean%20facility%20managers%20showing%20effective%20collaboration%20and%20problem%20solving%20in%20bright%20modern%20office%20with%20Korean%20people&width=600&height=400&seq=real-insurance-korean-001&orientation=landscape"
                    alt="케어인슈의 실질적 지원"
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="flex items-center gap-3 mb-4">
                  <i className="ri-checkbox-circle-line text-3xl text-blue-600"></i>
                  <h4 className="text-xl font-bold text-gray-900 whitespace-nowrap">케어인슈</h4>
                </div>
                <ul className="space-y-3">
                  <li className="flex items-start gap-3">
                    <i className="ri-check-double-line text-blue-600 mt-1"></i>
                    <div>
                      <p>신속 대응</p>
                      <p>신속한 현장 조사 및 면담</p>
                    </div>
                  </li>
                  <li className="flex items-start gap-3">
                    <i className="ri-check-double-line text-blue-600 mt-1"></i>
                    <div>
                      <p>평가 연계</p>
                      <p>평가 점수 향상 기여</p>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Section 4: 평가 전중후 지속 지원 */}
        <div className="mb-24">
          <div className="bg-gradient-to-br from-white to-blue-50 rounded-3xl p-12 shadow-xl border-2 border-blue-500/20">
            <div className="mb-8">
              <h3 className="text-2xl md:text-3xl font-bold text-gray-900">평가 전·중·후 지속 지원</h3>
            </div>

            <div className="relative mb-12">
              <img 
                src="https://readdy.ai/api/search-image?query=Korean%20elderly%20care%20facility%20quality%20evaluation%20and%20assessment%20process%20with%20Korean%20professional%20evaluators%20reviewing%20standards%20and%20documentation%20in%20long-term%20care%20center%20showing%20systematic%20inspection%20and%20quality%20management%20with%20Korean%20healthcare%20staff%20presenting%20evaluation%20materials%20in%20organized%20modern%20facility%20environment%20with%20Korean%20people&width=1400&height=500&seq=evaluation-process-korean-assessment-002&orientation=landscape"
                alt="지속적인 지원"
                className="w-full h-[400px] object-cover rounded-2xl shadow-lg"
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-calendar-check-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-3 whitespace-nowrap">평가 전</h4>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-blue-500 mt-1"></i>
                    <span>평가 항목 분석</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-blue-500 mt-1"></i>
                    <span>사고 기록 정리</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-blue-500 mt-1"></i>
                    <span>평가 대비 컨설팅</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-file-search-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-3 whitespace-nowrap">평가 중</h4>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-blue-500 mt-1"></i>
                    <span>서류 제출 지원</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-blue-500 mt-1"></i>
                    <span>질의 대응 지원</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-blue-500 mt-1"></i>
                    <span>증빙 자료 제공</span>
                  </li>
                </ul>
              </div>

              <div className="bg-white rounded-2xl p-6 shadow-md">
                <div className="w-12 h-12 bg-blue-100 rounded-xl flex items-center justify-center mb-4">
                  <i className="ri-line-chart-line text-2xl text-blue-600"></i>
                </div>
                <h4 className="text-lg font-bold text-gray-900 mb-3 whitespace-nowrap">평가 후</h4>
                <ul className="space-y-2">
                  <li className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-blue-500 mt-1"></i>
                    <span>결과 분석</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-blue-500 mt-1"></i>
                    <span>개선 실행</span>
                  </li>
                  <li className="flex items-start gap-2 text-sm text-gray-600">
                    <i className="ri-checkbox-circle-fill text-blue-500 mt-1"></i>
                    <span>지속적 품질 관리</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        {/* Section 5: 5가지 전문 지원 서비스 */}
        <div className="mb-24">
          <div className="text-center mb-12">
            <h3 className="text-3xl font-bold text-gray-900 whitespace-nowrap">5가지 전문 지원 서비스</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {/* Support 1 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-purple-500/20">
              <div className="relative h-48 mb-6 rounded-xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=professional%20Korean%20healthcare%20business%20consultants%20conducting%20comprehensive%20evaluation%20preparation%20consulting%20session%20with%20detailed%20strategic%20planning%20documentation%20review%20quality%20standards%20analysis%20and%20systematic%20assessment%20readiness%20training%20in%20modern%20bright%20office%20environment%20showing%20organized%20methodical%20approach%20to%20facility%20evaluation%20compliance%20with%20Korean%20consultants%20guiding%20Korean%20healthcare%20managers%20through%20evaluation%20criteria%20and%20best%20practices%20with%20Korean%20people&width=500&height=400&seq=support1-eval-prep-korean-consulting-009&orientation=squarish"
                  alt="평가 대비 컨설팅"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-file-list-3-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3 whitespace-nowrap">평가 대비 컨설팅</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>평가 항목별 준비</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>서류 작성 지원</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>모의 평가 실시</span>
                </li>
              </ul>
            </div>

            {/* Support 2 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-purple-500/20">
              <div className="relative h-48 mb-6 rounded-xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=comprehensive%20professional%20Korean%20healthcare%20staff%20training%20and%20education%20program%20with%20experienced%20Korean%20instructor%20conducting%20detailed%20workshop%20on%20elderly%20care%20safety%20protocols%20emergency%20response%20procedures%20proper%20caregiving%20techniques%20and%20quality%20standards%20in%20bright%20modern%20training%20facility%20with%20engaged%20Korean%20healthcare%20workers%20actively%20participating%20taking%20notes%20using%20training%20materials%20and%20practicing%20skills%20showing%20systematic%20employee%20development%20and%20professional%20skill%20enhancement%20for%20long-term%20care%20excellence%20with%20Korean%20people&width=500&height=400&seq=support2-staff-training-korean-education-009&orientation=squarish"
                  alt="직원 교육 프로그램"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-team-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3 whitespace-nowrap">직원 교육</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>사고 예방 교육</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>응급 대응 훈련</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>법규 윤리 교육</span>
                </li>
              </ul>
            </div>

            {/* Support 3 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-purple-500/20">
              <div className="relative h-48 mb-6 rounded-xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Korean%20safety%20inspector%20and%20Korean%20facility%20manager%20conducting%20detailed%20safety%20inspection%20in%20bright%20modern%20Korean%20nursing%20home%20checking%20emergency%20equipment%20fire%20safety%20systems%20and%20security%20protocols%20with%20clipboard%20and%20safety%20checklist%20professional%20Korean%20healthcare%20environment%20with%20Korean%20staff%20members%20ensuring%20comprehensive%20safety%20standards%20and%20risk%20management%20procedures&width=500&height=400&seq=support3-korean-safety-inspection-new-009&orientation=squarish"
                  alt="안전 관리 컨설팅"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-shield-check-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3 whitespace-nowrap">안전 관리</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>시설 안전 점검</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>위험 요소 개선</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>안전 매뉴얼 작성</span>
                </li>
              </ul>
            </div>

            {/* Support 4 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-purple-500/20">
              <div className="relative h-48 mb-6 rounded-xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Professional%20Korean%20attorney%20in%20modern%20law%20office%20providing%20detailed%20legal%20consultation%20to%20Korean%20elderly%20care%20facility%20director%20reviewing%20liability%20insurance%20contracts%20and%20legal%20documents%20on%20desk%20with%20law%20books%20in%20background%20professional%20business%20attire%20bright%20office%20lighting%20Korean%20professionals%20serious%20discussion&width=500&height=400&seq=support4-korean-legal-002&orientation=squarish"
                  alt="법률 자문 서비스"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-scales-3-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3 whitespace-nowrap">법률 자문</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>사고 법률 자문</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>분쟁 조정 지원</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>법규 준수 점검</span>
                </li>
              </ul>
            </div>

            {/* Support 5 */}
            <div className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2 border-2 border-purple-500/20">
              <div className="relative h-48 mb-6 rounded-xl overflow-hidden">
                <img 
                  src="https://readdy.ai/api/search-image?query=Korean%20business%20consultant%20in%20professional%20suit%20presenting%20comprehensive%20financial%20reports%20and%20operational%20management%20strategies%20to%20Korean%20nursing%20facility%20director%20in%20bright%20modern%20Korean%20office%20with%20large%20windows%20showing%20Seoul%20cityscape%20with%20detailed%20charts%20graphs%20and%20documents%20on%20conference%20table%20both%20Korean%20professionals%20engaged%20in%20strategic%20business%20planning%20discussion%20with%20laptops%20and%20analytical%20materials&width=500&height=400&seq=support5-korean-business-consulting-new-047&orientation=squarish"
                  alt="경영 컨설팅"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="w-14 h-14 bg-purple-100 rounded-xl flex items-center justify-center mb-4">
                <i className="ri-line-chart-line text-2xl text-purple-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-900 mb-3 whitespace-nowrap">경영 컨설팅</h4>
              <ul className="space-y-2">
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>운영 효율화</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>비용 절감 전략</span>
                </li>
                <li className="flex items-start gap-2 text-sm text-gray-600">
                  <i className="ri-check-line text-purple-500 mt-0.5"></i>
                  <span>장기 발전 계획</span>
                </li>
              </ul>
            </div>

            {/* 기대 효과 */}
            <div className="bg-white rounded-3xl shadow-lg p-8 md:p-12 border border-gray-100">
              <div className="text-center mb-8">
                <div className="w-16 h-16 bg-yellow-400 rounded-2xl flex items-center justify-center mx-auto mb-6">
                  <i className="ri-trophy-line text-3xl text-white"></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">기대 효과</h3>
                <p className="text-gray-900">케어인슈와 함께하면 이런 효과를 기대할 수 있습니다</p>
              </div>
              <div className="space-y-6">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-yellow-400 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-line-chart-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">평가 등급 상승</h4>
                    <p className="text-gray-900">체계적인 관리로 평가 등급 향상</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-blue-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-shield-check-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">사고 발생률 감소</h4>
                    <p className="text-gray-900">예방 중심의 안전 관리</p>
                  </div>
                </div>
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className="ri-money-dollar-circle-line text-xl text-white"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-2">보험료 절감</h4>
                    <p className="text-gray-900">낮은 사고율로 지속적인 보험료 절감</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Section 6: 최종 비교 - 보험을 넘어 평가까지 */}
        <div className="mb-12">
          <div className="text-center mb-12">
            <h3 className="text-2xl md:text-4xl font-bold text-gray-900">보험을 넘어, 운영 평가까지 함께 합니다.</h3>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
            {/* 일반 보험 */}
            <div className="bg-gradient-to-br from-red-50 to-red-100 rounded-2xl p-6 md:p-8 border-2 border-red-200">
              <div className="bg-red-600 text-white text-center py-3 rounded-xl mb-6 text-lg md:text-xl font-bold">
                일반 보험
              </div>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-3 h-3 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-sm md:text-base text-gray-800">사고 보상만 제공</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-3 h-3 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-sm md:text-base text-gray-800">평가와 무관한 처리</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-3 h-3 bg-red-600 rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-sm md:text-base text-gray-800">일회성 관계</p>
                </div>
              </div>
              <div className="bg-white rounded-xl p-4 md:p-6 mt-6">
                <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                  <strong className="text-red-600">보험금 지급 후 종료</strong>되는 단순한 관계로, 시설 운영 개선에는 도움이 되지 않습니다.
                </p>
              </div>
            </div>

            {/* 케어인슈 */}
            <div className="bg-gradient-to-br from-[#4A90E2]/10 to-[#4A90E2]/20 rounded-2xl p-6 md:p-8 border-2 border-[#4A90E2]/30">
              <div className="bg-[#4A90E2] text-white text-center py-3 rounded-xl mb-6 text-lg md:text-xl font-bold">
                케어인슈
              </div>
              <div className="space-y-4">
                <div className="flex items-start gap-3">
                  <div className="w-3 h-3 bg-[#4A90E2] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-sm md:text-base text-gray-800">사고 보상 + 평가 지원</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-3 h-3 bg-[#4A90E2] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-sm md:text-base text-gray-800">평가 연계 시스템</p>
                </div>
                <div className="flex items-start gap-3">
                  <div className="w-3 h-3 bg-[#4A90E2] rounded-full mt-2 flex-shrink-0"></div>
                  <p className="text-sm md:text-base text-gray-800">지속적 파트너십</p>
                </div>
              </div>
              <div className="bg-white rounded-xl p-4 md:p-6 mt-6">
                <p className="text-sm md:text-base text-gray-700 leading-relaxed">
                  <strong className="text-[#4A90E2]">보험과 평가를 연계</strong>하여 시설 운영의 질적 향상을 함께 도모합니다.
                </p>
              </div>
            </div>
          </div>

          {/* 기대 효과 */}
          <div className="bg-emerald-600 text-white rounded-xl p-6">
            <div className="text-center text-2xl font-bold mb-4">케어인슈와 함께하면</div>
            <div className="bg-white text-gray-800 rounded-lg p-6">
              <div className="flex items-start gap-3 mb-4">
                <i className="ri-trophy-line text-3xl text-emerald-600 flex-shrink-0"></i>
                <p className="font-bold">평가와 보험을 연계한 통합 관리 시스템으로</p>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                <div className="bg-emerald-50 rounded-lg p-5 border-2 border-emerald-200">
                  <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mb-3 mx-auto">
                    <i className="ri-line-chart-line text-white text-xl"></i>
                  </div>
                  <p className="text-center font-semibold text-gray-800 mb-2">평가 등급 향상</p>
                  <p className="text-center text-sm text-gray-600">평가 기준에 맞춘<br />체계적 관리</p>
                </div>
                <div className="bg-emerald-50 rounded-lg p-5 border-2 border-emerald-200">
                  <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mb-3 mx-auto">
                    <i className="ri-shield-check-line text-white text-xl"></i>
                  </div>
                  <p className="text-center font-semibold text-gray-800 mb-2">사고 발생률 감소</p>
                  <p className="text-center text-sm text-gray-600">예방 중심의<br />안전 관리</p>
                </div>
                <div className="bg-emerald-50 rounded-lg p-5 border-2 border-emerald-200">
                  <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mb-3 mx-auto">
                    <i className="ri-settings-3-line text-white text-xl"></i>
                  </div>
                  <p className="text-center font-semibold text-gray-800 mb-2">운영 효율 개선</p>
                  <p className="text-center text-sm text-gray-600">전문 컨설팅과<br />지속 지원</p>
                </div>
              </div>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
                <div className="bg-emerald-50 rounded-lg p-5 border-2 border-emerald-200">
                  <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mb-3 mx-auto">
                    <i className="ri-star-line text-white text-xl"></i>
                  </div>
                  <p className="text-center font-semibold text-gray-800 mb-2">서비스 품질 향상</p>
                  <p className="text-center text-sm text-gray-600">직원 교육과<br />품질 관리</p>
                </div>
                <div className="bg-emerald-50 rounded-lg p-5 border-2 border-emerald-200">
                  <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mb-3 mx-auto">
                    <i className="ri-heart-line text-white text-xl"></i>
                  </div>
                  <p className="text-center font-semibold text-gray-800 mb-2">입소자 만족도 증가</p>
                  <p className="text-center text-sm text-gray-600">안전하고 질 높은<br />케어</p>
                </div>
                <div className="bg-emerald-50 rounded-lg p-5 border-2 border-emerald-200">
                  <div className="w-12 h-12 bg-emerald-600 rounded-full flex items-center justify-center mb-3 mx-auto">
                    <i className="ri-building-line text-white text-xl"></i>
                  </div>
                  <p className="text-center font-semibold text-gray-800 mb-2">시설 신뢰도 상승</p>
                  <p className="text-center text-sm text-gray-600">체계적 사고<br />대응 시스템</p>
                </div>
              </div>
              <p className="mt-4 text-center">
                <strong>평가 등급 향상과 사고 예방</strong>을 동시에 달성하여, 시설의 경쟁력을 높이고 지속 가능한 운영을 지원합니다.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
